import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const ArtworkList = lazy(() => import("../pages/artwork/ArtworkList"));
const ArtworkEdit = lazy(() => import("../pages/artwork/ArtworkEdit"));
const ArtworkAdd = lazy(() => import("../pages/artwork/ArtworkAdd"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/artwork" />
    ),
  },
  {
    path: "/artwork",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ArtworkList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/artwork/edit-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
           <ArtworkEdit /> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/artwork/add-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ArtworkAdd/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };